<template>
  <section class="settings section">
    <form
      class="settings__form"
      @submit.prevent
    >
      <h2>
        Запросить смену пароля
      </h2>
      <fp-input
        v-model="email"
        placeholder="email"
        type="email"
      />
      <fp-button
        primary
        :disabled="v$.$invalid || sent"
        @click="submit"
      >
        {{ sent ? 'Email выслан' : 'Выслать email' }}
      </fp-button>
    </form>
  </section>
</template>

<script setup>
import { ref } from 'vue';
import { email as emailValidator, required } from '@vuelidate/validators';
import { useVuelidate } from '@vuelidate/core';

definePageMeta({
  middleware: 'only-unauthed'
});

const {$pb} = useNuxtApp();

const email = ref('');
const sent = ref(false);

const rules = {
  email: {
    required,
    email: emailValidator
  }
};

const v$ = useVuelidate(rules, { email });

const submit = async () => {
  sent.value = true;
  await $pb.collection('users').requestPasswordReset(email.value);
};
</script>

<style scoped lang="scss">
.settings {
  flex-grow: 1;
  background: white;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 64px 32px;
}

.settings__form {
  display: flex;
  flex-direction: column;
  gap: 32px;
  width: 350px;
}

h2 {
  font-weight: bold;
  font-size: x-large;
}
</style>
